"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TYPOGRAPHY_FONT_WEIGHTS = exports.TYPOGRAPHY_TEXT_TRANSFORMS = exports.FONT_SLOT_BY_CHOICE = exports.FONT_SLOTS = exports.TYPOGRAPHY_FONT_FAMILY_CHOICES = exports.TYPOGRAPHY_ROLES = exports.DEFAULT_BRAND_TYPOGRAPHY = exports.DEFAULT_BRAND_FONT_FAMILY = exports.MEDIA_BORDER_RADIUS_CSS = exports.BUTTON_BORDER_RADIUS_CSS = exports.ENABLE_SHOPPER_BRAND_SETTINGS = void 0;
exports.effectiveFontFamilyName = effectiveFontFamilyName;
exports.compareTypographyRoles = compareTypographyRoles;
exports.fontFamilyBySlot = fontFamilyBySlot;
exports.getActiveFontFamilies = getActiveFontFamilies;
// Deploy the settings contract before any shopper-visible output changes.
// The shopper rollout opts in explicitly after the backend/admin foundation is live.
exports.ENABLE_SHOPPER_BRAND_SETTINGS = false;
// Shared by storefront button rendering and the AI-create prompt context.
exports.BUTTON_BORDER_RADIUS_CSS = {
    SQUARE: '0',
    ROUNDED: '0.2rem',
    PILL: '9999px',
};
exports.MEDIA_BORDER_RADIUS_CSS = {
    SQUARE: '0',
    ROUNDED: '0.2rem',
    PILL: '9999px',
};
exports.DEFAULT_BRAND_FONT_FAMILY = 'Inter';
/** The family name the storefront renders for a slot the client left unset. */
function effectiveFontFamilyName(family) {
    var _a;
    return ((_a = family === null || family === void 0 ? void 0 : family.name) === null || _a === void 0 ? void 0 : _a.trim()) || exports.DEFAULT_BRAND_FONT_FAMILY;
}
// Fallback type scale for AI-create brand-styling prompts when a client has
// not persisted header/title/body metrics.
exports.DEFAULT_BRAND_TYPOGRAPHY = {
    headerFontSize: 20,
    headerFontWeight: 400,
    bodyFontSize: 16,
    bodyFontWeight: 400,
    titleFontSize: 24,
    titleFontWeight: 400,
};
/**
 * The 16 typography roles a brand can configure. The shopper frontend maps
 * each role to one or more rendered text elements (e.g. product card titles
 * use `productTitle`).
 */
exports.TYPOGRAPHY_ROLES = [
    'displayHeading',
    'headingText',
    'productTitle',
    'featureTitle',
    'bodyText',
    'captionText',
    'price',
    'compareAtPrice',
    'buttonText',
    'labelText',
    'navText',
    'badgeText',
    'statusText',
    'linkText',
    'tabText',
    'promoText',
];
const TYPOGRAPHY_ROLE_ORDER = exports.TYPOGRAPHY_ROLES.reduce((acc, role, idx) => {
    acc[role] = idx;
    return acc;
}, {});
/**
 * Stable comparator for typography roles, ordered by the position in
 * `TYPOGRAPHY_ROLES` (UX hierarchy: display headings first, promo text last).
 * Use this for any sort that crosses an API/UI boundary so the backend and
 * admin agree on ordering.
 */
function compareTypographyRoles(a, b) {
    return TYPOGRAPHY_ROLE_ORDER[a] - TYPOGRAPHY_ROLE_ORDER[b];
}
exports.TYPOGRAPHY_FONT_FAMILY_CHOICES = [
    'PRIMARY',
    'SECONDARY',
    'FONT_3',
    'FONT_4',
    'FONT_5',
];
exports.FONT_SLOTS = [
    'primary',
    'secondary',
    'font3',
    'font4',
    'font5',
];
exports.FONT_SLOT_BY_CHOICE = {
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
    FONT_3: 'font3',
    FONT_4: 'font4',
    FONT_5: 'font5',
};
/** The one place that knows which settings field backs each font slot. */
function fontFamilyBySlot(settings) {
    var _a, _b, _c;
    return {
        primary: settings.primaryFontFamily,
        secondary: settings.secondaryFontFamily,
        font3: (_a = settings.font3FontFamily) !== null && _a !== void 0 ? _a : null,
        font4: (_b = settings.font4FontFamily) !== null && _b !== void 0 ? _b : null,
        font5: (_c = settings.font5FontFamily) !== null && _c !== void 0 ? _c : null,
    };
}
exports.TYPOGRAPHY_TEXT_TRANSFORMS = [
    'NONE',
    'UPPERCASE',
    'LOWERCASE',
    'CAPITALIZE',
];
/**
 * CSS `font-weight` values surfaced by the admin typography dropdown.
 * This is a UI convenience list, not a validation source of truth —
 * tooling that validates stored values should check the API contract.
 */
exports.TYPOGRAPHY_FONT_WEIGHTS = [
    100, 200, 300, 400, 500, 600, 700, 800, 900,
];
// Fonts 3-5 load only when a typography override references them, so an
// unused font never delays first paint.
function getActiveFontFamilies(settings) {
    const usedSlots = new Set(['primary', 'secondary']);
    for (const override of settings.typographyRoleOverrides) {
        usedSlots.add(exports.FONT_SLOT_BY_CHOICE[override.fontFamily]);
    }
    const bySlot = fontFamilyBySlot(settings);
    return exports.FONT_SLOTS.filter((slot) => usedSlots.has(slot))
        .map((slot) => bySlot[slot])
        .filter((family) => { var _a; return Boolean((_a = family === null || family === void 0 ? void 0 : family.files) === null || _a === void 0 ? void 0 : _a.length); });
}
